<template>
  <div class="main">
    <van-image
      fit="cover"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/5.jpg"
      class="banner"
    />
    <!-- 产品介绍 -->
    <Introduce :title='"产品介绍"' :desc='"灵创是一套支持VR、AR的3D互动教学产品，包括3D编辑器和播放器两个部分。灵创具备海量的3D模型教学资源，不仅支持K12、同时也支持中高职。老师仅需几分钟，就可以把3D模型变成一节知识点丰富的教学课件。不仅如此，灵创课件还支持多种教学终端，根据不同的终端特点，体现出个性化的教学特色。"' :descMobile='"灵创是一套支持VR、AR的3D互动教学产品，包括3D编辑器和播放器两个部分。具备海量的3D模型教学资源，不仅支持K12、也支持中高职。老师仅需几分钟，就把3D模型变成一节知识点丰富的教学课件。不仅如此，课件还支持多种终端，可体现出个性化的教学特色。"' :img='"https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/6.jpg"'></Introduce>
    <!-- 主要功能模块 -->
    <Module title="产品特性" :list='plan'></Module>
    <!-- 多端设备支持 -->
    <Constitute :title="'多端支持'" :constitute='constitute'></Constitute>
    <!-- 微课件 -->
    <div class="tiny">
      <div class="title">互动微课</div>
      <div class="contentVessel">
        <div class="content">
          <div class="list" v-for="item of tiny" :key="item">
            <img :src="item" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Introduce from '@/component/introduce'
import Constitute from '@/component/constitute'
import Module from '@/component/module';
export default {
  components: {
    Introduce,
    Constitute,
    Module
  },
  data() {
    return {
      list: [1, 2, 3, 4],
      plan: [
        {
          title: '多媒体知识点标记',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/12.png',
          desc: '讲授与学习的过程更为生动有趣'
        },
        {
          title: '3D模型互动',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/13.png',
          desc: '在学习过程中学生参与课件交互'
        },
        {
          title: '模型动画和特效',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/14.png',
          desc: '互动的知识点效果既形象又逼真'
        },
        {
          title: '跨平台多终端',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/15.png',
          desc: 'XR设备、手机、Pad等应有尽有'
        }
      ],
      constitute: [
        {
          title: 'Windows大屏',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/3.png'
        },
        {
          title: '安卓AVR',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/4.png'
        },
        {
          title: '燧光MR',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/2.png'
        },
        {
          title: '未来感知',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/1.png'
        }
      ],
      tiny: [
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/8.jpg',
        // 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/9.png',
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/10.jpg',
        'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/chuang/11.jpg'
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.main {
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .details {
    margin: 0 auto;
    padding-top: 150px;
    width: 1200px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
    }
    .content {
      // display: flex;
      margin-top: 50px;
      img:nth-child(1) {
        width: 740px;
        height: 290px;
        margin-right: 40px;
      }
      img:nth-child(2) {
        width: 420px;
        height: 290px;
      }
    }
    .desc {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #80889a;
      line-height: 40px;
      margin-top: 50px;
    }
  }
  .tiny {
    width: 100%;
    width: 1200px;
    margin: 0 auto;
    padding-top: 113px;
    padding-bottom: 180px;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
      text-align: center;
    }
    .content {
      display: flex;
      justify-content: space-around;
      margin-top: 40px;
      .list {
        width: 28%;
        border: 8px solid #fafafa;
        img {
          width: 100%;
          display: block;
        }
      }
    }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .banner {
      width: 100%;
      height: 348px;
      display: block;
    }
    .tiny{
      width: 100%;
      height: auto;
      padding-top: 1px;
      padding-bottom: 120px;
      .title{
        font-size: 44px;
        margin-top: 80px;
      }
      .contentVessel{
        width: 100%;
        overflow-x: auto;
      }
      .content{
        width: 1800px;
        margin-top: 60px;
        justify-content: space-between;
        padding-right: 48px;
        .list{
          width: 546px;
          height: 352px;
          margin-left: 48px;
          img{
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
